export const namespacedPrefix = '[CYCLES]';
